module.exports = __webpack_public_path__ + "img/142.9f373689.jpg";